import { useEffect, useState } from 'react';

const LINES = ['Building the', "QxAME's most capable", 'AI Assistant.'];

const CHAR_DELAY = 55; // ms per character
const LINE_PAUSE = 350; // ms between lines

export function TypewriterHeadline() {
  const [lineIdx, setLineIdx] = useState(0);
  const [charIdx, setCharIdx] = useState(0);

  useEffect(() => {
    if (lineIdx >= LINES.length) return;

    const current = LINES[lineIdx];

    if (charIdx < current.length) {
      const t = setTimeout(() => setCharIdx((c) => c + 1), CHAR_DELAY);
      return () => clearTimeout(t);
    }

    // Current line finished — pause, then move to the next line.
    const t = setTimeout(() => {
      setLineIdx((l) => l + 1);
      setCharIdx(0);
    }, LINE_PAUSE);
    return () => clearTimeout(t);
  }, [lineIdx, charIdx]);

  const done = lineIdx >= LINES.length;

  return (
    <h1 className="landing__headline">
      {LINES.map((line, i) => {
        let text = '';
        if (i < lineIdx) text = line;
        else if (i === lineIdx) text = line.slice(0, charIdx);

        const showCursor = i === lineIdx || (done && i === LINES.length - 1);

        return (
          <span className="landing__headline-line" key={i}>
            {text || '\u00A0'}
            {showCursor && <span className="landing__cursor" aria-hidden />}
          </span>
        );
      })}
    </h1>
  );
}
